import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45a5e9a9")

_pushScopeId("data-v-45a5e9a9")
const _hoisted_1 = { class: "type-item" }
const _hoisted_2 = { class: "type-detail" }
const _hoisted_3 = { class: "type-detail-text" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "type-detail-go-ico" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "type-btn-text"
}
const _hoisted_6 = {
  key: 1,
  class: "type-btn-text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_onTouchActive = _resolveDirective("onTouchActive")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("div", {
      class: "type-item-ico gtm-community-btn",
      "data-community": _ctx.name,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jumpFanPage(_ctx.name)))
    }, [
      _createVNode("div", {
        class: ["ico", _ctx.name]
      }, null, 2)
    ], 8, ["data-community"]), [
      [_directive_onTouchActive]
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.name), 1),
      _withDirectives(_createVNode("div", {
        class: "type-detail-go gtm-community-btn",
        "data-community": _ctx.name,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jumpFanPage(_ctx.name)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('goFans')) + " ", 1),
        _hoisted_4
      ], 8, ["data-community"]), [
        [_directive_onTouchActive]
      ])
    ]),
    _withDirectives(_createVNode("div", {
      class: ["type-btn gtm-community-btn", { geted: _ctx.hasGet }],
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getGift(_ctx.name))),
      "data-community": _ctx.name
    }, [
      (_ctx.hasGet)
        ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('hasGet')), 1))
        : (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('get')), 1))
    ], 10, ["data-community"]), [
      [_directive_onTouchActive]
    ])
  ]))
})